<template>
  <div>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title>Solicitar PickUp Nacional</v-card-title>
        <v-card-text>                    
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-dialog
                ref="dialogFecha"
                v-model="modalFecha"
                :return-value.sync="fecha"
                persistent
                width="290px"
                :disabled="disableAll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecha"
                    label="Fecha de Recolecta"
                    append-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[reglas.requeridoTxt]"
                    required
                    :disabled="disableAll"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha"
                  scrollable
                  no-title
                  :allowed-dates="allowedDates"
                  @input="
                    modalFecha = false;
                    $refs.dialogFecha.save(fecha);
                  "
                  :disabled="disableAll"
                >
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-dialog
                ref="dialogHora"
                v-model="modalHora"
                :return-value.sync="hora"
                persistent
                width="290px"
                :disabled="disableAll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="hora"
                    label="Hora de Recolecta"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[reglas.requeridoTxt]"
                    required
                    :disabled="disableAll"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="hora" min="9:00" max="17:00" :allowed-hours="allowedHours">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogHora.save(hora)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-dialog
                ref="dialogHoraC"
                v-model="modalHoraC"
                :return-value.sync="horaC"
                persistent
                width="290px"
                :disabled="disableAll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="horaC"
                    label="Cerrado a Las"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[reglas.requeridoTxt]"
                    required
                    :disabled="disableAll"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="horaC" :allowed-hours="allowedHoursC">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogHoraC.save(horaC)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="indicaciones"
                label="Indicaciones"
                append-icon="edit"
                :disabled="disableAll"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer
          ><v-btn :disabled="disableAll" outlined color="primary" @click="solicitar()">
            Solicitar Pickup
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-overlay :value="overlay">
        <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from '../components/Waiting.vue';
import apicon from '../plugins/apicon';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components:{
    Waiting
  },
  created: function () {},
  data() {
    return {
      valid: true,            
      modalFecha: false,
      fecha: null,
      modalHora: false,
      hora: null,
      modalHoraC: false,
      horaC: null,
      indicaciones: null,     
      overlay: false,
      disableAll: false,
    };
  },
  methods: {    
    solicitar: async function () {
      if (this.$refs.form.validate()) {
        this.overlay = true;          
        var datos = {
          id: this.id,          
          hora_recolecta: this.hora,
          fecha_recolecta: this.fecha,
          cerrado_a: this.horaC,
          indicaciones: this.indicaciones,
        };        
        apicon.saveDataApi(apicon.getApiBaseUrl() + "crearpickup", datos).then((result) => {                      
            if(result.status){
                this.overlay = false;
                this.disableAll = true;
                this.$swal(result.message);            
            }else{
                this.overlay = false;
                this.$swal('Algo salio mal');
            }                      
        });
      }      
    },     
    allowedDates: function(val){      
			return (val >= new Date().toISOString().substring(0,10)) && (new Date(val).getDay() != 6) && (new Date(val).getDay() != 5);      
		},		
    allowedHours: function(val){
      return (this.fecha == new Date().toISOString().substring(0,10) ? val > new Date().getHours() : true);
    },
    allowedHoursC: function(val){      
      return (val > new Date(this.fecha + ' ' + this.hora).getHours());
    }
  },  
  mounted: function () {
    apicon.setAuthHeaders();    
  },
};
</script>